import { ReportControlField } from 'models';

export const sortOptions: ReportControlField[] = [
  {
    label: '#portal.report.bar.option.label.omistaja',
    value: 1,
  },
  {
    label: '#portal.report.bar.option.label.osakkeet',
    value: 2,
  },
  {
    label: '#portal.report.bar.option.label.tila',
    value: 3,
  },
];

export const orderOptions: ReportControlField[] = [
  {
    label: '#portal.report.bar.option.label.nouseva',
    value: 1,
  },
  {
    label: '#portal.report.bar.option.label.laskeva',
    value: 2,
  },
];

export const publicOptions: ReportControlField[] = [
  {
    label: '#portal.report.bar.option.label.yes',
    value: 'true',
  },
  {
    label: '#portal.report.bar.option.label.no',
    value: 'false',
  },
];
